import { createStyle } from '@gluestack-style/react';
export const FormControlLabelText = createStyle({
    fontWeight: '$bold',
    color: '$gray800',
    _dark: {
        color: '$textDark50',
    },
    variants: {
        size: {
            sm: {
                props: {
                    fontSize: '$sm',
                },
            },
            md: {
                props: {
                    fontSize: '$md',
                },
            },
            lg: {
                props: {
                    fontSize: '$lg',
                    fontWeight: '$bold',
                },
            },
        },
    },
});
